import { t } from '../i18n.js';

/**
 * Via welke sensor de syslog van een bron binnenkomt (docs/besluiten/bron-naar-een-andere-klant.md): een
 * eigen sensor van de klant of een sensor van ADTS. De keuze is **expliciet** één sensor (optie B): bij
 * meer dan één sensor koos ZERO vroeger stilletjes de laagste-id, wat het verkeerde syslogadres opleverde.
 * `waarde` is het id van de gekozen sensor als tekst (leeg = nog niet gekozen).
 */
export function keuzes(sensoren, tenantId) {
  const eigen = sensoren.filter((s) => String(s.tenant.id) === String(tenantId));
  const adts = sensoren.filter((s) => s.own && String(s.tenant.id) !== String(tenantId));
  return { eigen, adts };
}

/** De standaard voor een nieuwe bron: één eigen sensor → die; geen eigen en één ADTS → die; anders een bewuste keuze. */
export function standaard(sensoren, tenantId) {
  const { eigen, adts } = keuzes(sensoren, tenantId);
  if (eigen.length === 1) return String(eigen[0].id);
  if (!eigen.length && adts.length === 1) return String(adts[0].id);
  return '';
}

const label = (s) => `${s.name} — ${s.address ? s.address : t('adres nog niet gemeld')}`;

export default function OntvangenVia({ sensoren, tenantId, waarde, opWijzig }) {
  const { eigen, adts } = keuzes(sensoren, tenantId);
  const geen = !eigen.length && !adts.length;
  return (
    <>
      <select value={waarde} onChange={(e) => opWijzig(e.target.value)}>
        <option value="">{t('— kies een sensor —')}</option>
        {eigen.length > 0 && (
          <optgroup label={t('Eigen sensor van de klant')}>
            {eigen.map((s) => <option key={s.id} value={s.id}>{label(s)}</option>)}
          </optgroup>
        )}
        {adts.length > 0 && (
          <optgroup label={t('Rechtstreeks naar een sensor van ADTS')}>
            {adts.map((s) => <option key={s.id} value={s.id}>{label(s)}</option>)}
          </optgroup>
        )}
      </select>
      {geen && <span className="err">{t('Er is nog geen sensor: maak er eerst een aan (Beheer › Klanten › Sensoren), anders komt er niets binnen.')}</span>}
      {!geen && !waarde && <span className="err">{t('Kies een sensor; anders weet ADTS ZERO niet waar de firewall zijn syslog naartoe stuurt.')}</span>}
    </>
  );
}
